import axios from 'axios';

const BASE_URL = process.env.NODE_ENV === 'production'
    ? '/app/api'
    : '';

export const AxiosInstance = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
});
